import api from '../api/api.js'

export default {
  namespaced: true,

  state: {
    /**
     * 初期値はカテゴリID「全て」
     * 画面遷移しても選択したカテゴリIDを保持
     */
    dashboardSelectedCategoryId: '00',
    predictSelectedCategoryId: '00',

    category: {}
  },

  getters: {
    dashboardSelectedCategoryId(state) {
      return state.dashboardSelectedCategoryId
    },
    predictSelectedCategoryId(state) {
      return state.predictSelectedCategoryId
    },
    category(state) {
      return state.category
    }
  },

  mutations: {
    dashboardSelectedCategoryId(state, payload) {
      state.dashboardSelectedCategoryId = payload
    },
    predictSelectedCategoryId(state, payload) {
      state.predictSelectedCategoryId = payload
    },
    category(state, payload) {
      state.category = payload
    },
    resetCategory(state) {
      state.category = {}
    }
  },

  actions: {
    /**
     * カテゴリ情報取得
     */
    getCategory({ commit }, payload) {
      return api.get('/api/v2/category/get', {})
        .then((res) => {
          commit('category', res.data.category)
        })
    },

    /**
     * ダッシュボードのカテゴリ一覧のカテゴリ選択
     */
    setDashboardSelectedCategoryId({ commit }, payload) {
      commit('dashboardSelectedCategoryId', payload)
    },

    /**
     * 予測シミュレーションのカテゴリ一覧のカテゴリ選択
     */
    setPredictSelectedCategoryId({ commit }, payload) {
      commit('predictSelectedCategoryId', payload)
    },

    /**
     * ログアウト時にcategory一覧をリセットする
     */
    resetCategory({ commit }) {
      commit('resetCategory')
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/module/category.js